module.exports = __webpack_public_path__ + "img/scotia.0736b33b.jpg";